import { render, staticRenderFns } from "./PhaseTypeReview.vue?vue&type=template&id=86801302&scoped=true"
import script from "./PhaseTypeReview.vue?vue&type=script&lang=js"
export * from "./PhaseTypeReview.vue?vue&type=script&lang=js"
import style0 from "./PhaseTypeReview.vue?vue&type=style&index=0&id=86801302&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86801302",
  null
  
)

export default component.exports